// extracted by mini-css-extract-plugin
var _1 = "J3VQ_C7B";
var _2 = "J3VQ_C7B";
var _3 = "PXwFn2pd";
var _4 = "PXwFn2pd";
export { _1 as "article-info", _2 as "articleInfo", _3 as "no-break", _4 as "noBreak" }
